import { ReferralForm } from './ReferralForm';

// ----------------------------------------------------------------------

const ReferralPage = () => <ReferralForm />;

export default ReferralPage;
